<template>
  <div id="app">
    <Header v-if="$route.name != 'login' && $route.name != 'register' && $route.name != 'maintenance' && $route.name != 'forgot-password'" />
    <transition name="el-fade-in" mode="out-in">
      <div class="app-loading d-flex align-items-center justify-content-center" style="height: calc(100vh - 55px); width:100%;" v-if="eventLoading" key="event-loading">
        <lottie-player autoplay loop mode="normal" src="/static/lottie/holacon-loading-lottie.json" style="width: 400px"></lottie-player>
      </div>
      <router-view v-else key="event-wrapper-loading" />
    </transition>
  </div>
</template>

<script>
import "bootstrap";
import Swal from "sweetalert2";

import Header from "@/components/Header";
import UserMini from "@/components/UserMini";
import PaymentDetail from "@/components/PaymentDetail";
import CreditPackets from "@/components/CreditPackets";
import ActionableLabel from "@/components/ActionableLabel";
import PrintSchemeAddUpdate from "@/components/PrintSchemeAddUpdate";
import ParticipantAddOrUpdate from "@/components/ParticipantAddOrUpdate";
import FirmInfo from "@/pages/FirmInfo";
import ItemInfo from "@/components/ItemInfo";
import "./assets/js/app.js";
import EventBus from "@/helpers/event-bus.js";
import axios from "axios";
export default {
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.eventHome"),
      titleTemplate: "%s | Holacon - Event Management Console"
    };
  },
  name: "App",
  components: {
    Header,
    PaymentDetail,
    UserMini,
    CreditPackets,
    ActionableLabel,
    PrintSchemeAddUpdate,
    ParticipantAddOrUpdate,
    FirmInfo,
    ItemInfo
  },
  methods: {
    async accept() {
      this.showUpgradeUI = false;
      await this.$workbox.messageSW({ type: "SKIP_WAITING" });
    },
    sendCertificate() {
      this.sendCertificateLoading = true;
      var id = [];
      id.push(this.p.id);

      axios
        .post("participant/load", {
          sendCertificate: true,
          certificateSchemeID: this.certificateID,
          sendCertificateParticipantIDs: id,
          take: 1
        })
        .then(res => {
          this.sendCertificateLoading = false;
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
          }
        });
    },
    copySuccess() {
      this.$message.success(this.$t("message.copiedLink"));
    },
    copyCodeSuccess() {
      this.$message.success(this.$t("message.copiedCode"));
    },
    deleteItem(index) {
      this.$store.dispatch("deletePrintScheme", { index, context: this });
    },
    async itemAdded(item) {
      await this.$store.dispatch("getPrintSchemes");
      this.$store.state.printschemes.printForm.schemeID = item.id;
    },
    checkIn() {
      this.$store.dispatch("checkIn", { id: this.p.id, context: this });
    },
    printCard() {
      this.$store.dispatch("printCard", { context: this });
    },
    refreshCode() {
      axios
        .post("participant/refreshactivationcode", {
          id: this.p.id
        })
        .then(res => {
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
            this.$store.dispatch("getParticipant", this.p.id);
          }
        });
    },
    toggleBlock() {
      axios
        .post("participant/toggleisblocked", {
          id: this.p.id
        })
        .then(res => {
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
            this.$store.dispatch("getParticipant", this.p.id);
            this.$store.dispatch("getParticipants");
          }
        });
    },
    addProxy() {
      axios
        .post("participant/addproxy", {
          ...this.proxyForm,
          id: this.p.id
        })
        .then(res => {
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
            this.$store.dispatch("getParticipant", this.p.id);
            this.proxyModal = false;
            this.proxyForm = {
              reason: null,
              firstName: null,
              lastName: null
            };
          }
        });
    },
    changePaymentStatus(status, item, index) {
      axios
        .post("participant/changepaymentstatus", {
          id: item.id,
          paymentID: item.paymentID,
          status
        })
        .then(res => {
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
            this.$store.state.participantInfo.participant.paymentInfos[index].paymentStatus = status;
          }
        });
    },
    sendVoucher() {
      this.voucherLoading = true;
      var filter = {};
      if (this.$store.state.voucher.filter != null) {
        filter = {
          ...this.$store.state.voucher.filter
        };
      }
      axios
        .post("participant/load", {
          sendVoucherParticipantIDs: this.$store.state.voucher.ids,
          sendVoucher: true,
          sendVoucherType: this.$store.state.voucher.type,
          sendVoucherSchemeID: this.$store.state.voucher.templateID,
          take: 100,
          skip: 0,
          ...filter
        })
        .then(res => {
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
            this.$store.state.voucher.modalVisible = false;
          }

          this.voucherLoading = false;
        });
    },
    getUrlParams(url) {
      var params = {};
      var parser = document.createElement("a");
      parser.href = url;
      var query = parser.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        params[pair[0]] = decodeURIComponent(pair[1]);
      }
      return params;
    },
    deleteParticipant(index) {
      this.$store.dispatch("deleteParticipant", { index, context: this });
      this.$store.state.participantInfo.infoModalVisible = false;
    },
    itemUpdated(item) {
      this.$store.dispatch("getParticipant", item.id);
    }
  },
  data() {
    return {
      eventLoading: false,

      activeName: "first",
      detailDialog: false,
      detailData: null,
      participantData: null,
      proxyModal: false,
      firmModal: false,
      proxyForm: {
        reason: null,
        firstName: null,
        lastName: null
      },
      voucherLoading: false,
      packetDialog: false,
      reasons: this.$t("reason").split(","),
      schemeModal: false,
      showInfo: false,
      editModal: false,
      editForm: null,
      sendCertificateModal: false,
      sendCertificateLoading: false,
      certificateID: null,
      certificateValidationErrors: [],
      certificates: [],
      ids: null
    };
  },
  computed: {
    p() {
      return this.$store.state.participantInfo.participant;
    },
    c() {
      return this.$store.state.users;
    },
    d() {
      return this.$store.state.promotions;
    },
    wrapperLoading() {
      return this.$store.getters.wrapperLoading;
    }
  },
  watch: {
    "this.$store.state.participantInfo.infoModalVisible": function() {
      if (this.$store.state.participants.registrationInputs.length == 0) {
        this.$store.dispatch("getRegistrationInputs");
      }
    },
    "$store.state.voucher.modalVisible": function(val) {
      if (val) {
        this.$store.dispatch("getVoucherTemplates");
      }
    }
  },
  async mounted() {
    this.$root.$on("openCredits", () => {
      this.packetDialog = true;
    });
    EventBus.$on("eventLoading", payload => {
      this.eventLoading = payload;
      console.log("eventLoading", payload);
    });
  },
  async created() {
    await this.$store.dispatch("getEnums");
    var params = this.getUrlParams(window.location.href);
    if (params.TransactionId != undefined && params.TransactionId != null) {
      axios.post("payment/finishpayment", { transactionID: params.TransactionId }).then(res => {
        this.$router.replace({ query: null });
        if (res.data.alert.hasError) {
          Swal.fire({
            title: this.$t("message.paymentFailed"),
            text: res.data.alert.message,
            icon: "error",
            confirmButtonText: this.$t("event.buttons.close")
          });
        } else {
          this.$store.dispatch("getUser");

          Swal.fire({
            title: this.$t("message.paymentSuccess"),
            text: res.data.alert.message,
            icon: "success",
            confirmButtonText: this.$t("event.buttons.close")
          });
        }
      });
    }

    var token = localStorage.getItem("token");

    // if (window.location.hostname == 'app.holacon.com') {
    //   let OneSignalScript = document.createElement('script');
    //   OneSignalScript.setAttribute('src', 'https://cdn.onesignal.com/sdks/OneSignalSDK.js');
    //   document.head.appendChild(OneSignalScript);

    //   window.OneSignal = window.OneSignal || [];
    //   var initConfig = {
    //     appId: '7ef7de9c-3190-4172-a7e8-eb7ba01b94d3',
    //     safari_web_id: 'web.onesignal.auto.2b467c5d-2ccd-4e09-a57b-cb7ab9efd0c0',
    //     autoResubscribe: true,
    //     notifyButton: {
    //       enable: false,
    //     },
    //   };

    //   OneSignal.push(function() {
    //     OneSignal.SERVICE_WORKER_PARAM = {scope: '/push/onesignal/'};
    //     OneSignal.SERVICE_WORKER_PATH = 'push/onesignal/OneSignalSDKWorker.js';
    //     OneSignal.SERVICE_WORKER_UPDATER_PATH = 'push/onesignal/OneSignalSDKUpdaterWorker.js';
    //     OneSignal.init(initConfig);
    //     OneSignal.showNativePrompt();
    //   });

    // }
    if (window.location.hostname == "app.holacon.com") {
      this.$OneSignal.showNativePrompt();
    }

    if (this.$workbox) {
      this.$workbox.addEventListener("waiting", e => {
        this.showUpgradeUI = true;
      });
    }
  }
};
</script>

<style lang="less">
@import url("./assets/css/custom.less");
//@import url("./assets/icomoon.css");
</style>



// WEBPACK FOOTER //
// src/App.vue